import { render, staticRenderFns } from "./TableCellTypeNumber.vue?vue&type=template&id=6df664e0&scoped=true"
import script from "./TableCellTypeNumber.vue?vue&type=script&lang=js"
export * from "./TableCellTypeNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df664e0",
  null
  
)

export default component.exports